import { createElement, useEffect, useState, useCallback, useRef } from 'react';
import { Card, Button, Divider, Notification } from '@alifd/next';
import request from '@/utils/request';
import renderComponent from './render-form-block-component';
const EditForm = (props) => {
    const editTableRef = useRef();
    const [saveLoading, setSaveLoading] = useState(false);
    const { editType, url, editRow, formBlocks = [], __designMode, openPane, refreshList, field, changingField, } = props;
    const resetForm = useCallback(() => {
        field?.reset();
        editTableRef.current?.reset();
    }, [field]);
    const save = () => {
        field.validate((errors, values) => {
            if (!errors) {
                handleSubmit(values);
            }
        });
    };
    const handleSubmit = async (values) => {
        const method = editType === 'create' ? 'post' : 'put';
        try {
            setSaveLoading(true);
            await request[method](url, values);
            Notification.success({
                title: '保存成功',
            });
            setSaveLoading(false);
            refreshList();
            resetForm();
            openPane(['1']);
        }
        catch (error) {
            setSaveLoading(false);
        }
    };
    const cancle = () => {
        openPane(['1']);
        resetForm();
    };
    const extra = () => {
        return (createElement("div", null,
            createElement(Button, { text: true, type: "primary", onClick: save, loading: saveLoading }, "\u4FDD\u5B58"),
            createElement(Divider, { direction: "ver" }),
            createElement(Button, { text: true, onClick: cancle }, "\u53D6\u6D88")));
    };
    useEffect(() => {
        field?.setValues(editRow);
    }, [editRow, field]);
    useEffect(() => {
        if (editType === 'create') {
            resetForm();
        }
    }, [editType, field, resetForm]);
    return (createElement(Card, { free: true, hasBorder: false },
        createElement(Card.Header, { title: "\u8BE6\u60C5", extra: editType === 'view' ? null : extra() }),
        createElement(Card.Divider, null),
        createElement(Card.Content, null, renderComponent({ formBlocks, field, __designMode, changingField, editTableRef, editType }))));
};
export default EditForm;
